module.exports = __webpack_public_path__ + "static/media/eight.c2590b57.svg";